import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mountain } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { PillButton } from "../components/primitives";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const data = await login(form.email, form.password);
      const dest = location.state?.from || (data.role === "admin" ? "/admin" : "/portal");
      navigate(dest, { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1740712686694-24eb2ad2a16d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute bottom-10 left-10 text-white">
          <div className="font-display font-extrabold text-3xl">Welcome back.</div>
          <p className="text-white/70 mt-2">Manage your El Salvador retreat.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="flex items-center gap-2 font-display font-extrabold text-lg"><Mountain className="w-6 h-6 text-primary" /> La Vida Is Travel Fit</Link>
          <h1 className="mt-10 font-display font-extrabold text-3xl">Log in</h1>
          <p className="mt-2 text-foreground/60 text-sm">Access your travel portal.</p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <input required type="email" placeholder="Email" value={form.email} data-testid="login-email"
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full h-12 rounded-xl border border-black/10 px-4 focus:outline-none focus:ring-2 focus:ring-primary" />
            <input required type="password" placeholder="Password" value={form.password} data-testid="login-password"
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full h-12 rounded-xl border border-black/10 px-4 focus:outline-none focus:ring-2 focus:ring-primary" />
            {error && <div className="text-sm text-destructive" data-testid="login-error">{error}</div>}
            <PillButton type="submit" disabled={busy} data-testid="login-submit" className="w-full">{busy ? "Logging in…" : "Log in"}</PillButton>
          </form>
          <p className="mt-6 text-sm text-foreground/60">No account? <Link to="/register" className="text-primary font-medium">Create one</Link></p>
        </div>
      </div>
    </div>
  );
}
